<template>
  <div id="exampleListPage">
    <h1>全部案例</h1>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
